module.exports = __webpack_public_path__ + "static/11_Output2-da360340eb7de7f6d4a2c00b22473767.png";